const withAdmin = (url) => {
    return '/admin' + url
}

export {withAdmin}